import * as types from './mutation-types';
import parseRoomId from "../util/parseRoomId";
import appConfig from "../api/appConfig";

export const switchLanguage = ({ commit }, langCode) => {
  commit(types.SWITCH_LANGUAGE, langCode);
  commit(types.CLEAR_CAT);
  commit(types.CLEAR_SHOP);
  commit(types.UPDATE_PATH_FINDER_TARGET_SHOP, null);
};

export const switchFloor = ({ commit }, floorId) => {
  commit(types.SWITCH_FLOOR, floorId);
  commit(types.UPDATE_PATH_FINDER_TARGET_SHOP, null);
};

export const switchFloorByShopId = ({ commit, getters }, shopId) => {
  const rooms = getters.shopById(shopId).rooms;
  const floors = rooms.map(roomId => {
    return parseRoomId(roomId).getFloor();
  });
  if (floors.indexOf(getters.currentFloor) === -1) {
    commit(types.SWITCH_FLOOR, floors[0]);
  }
};

export const selectShop = ({ commit, getters, dispatch }, shopId) => {
  commit(types.SELECT_SHOP, shopId);
  commit(types.CLOSE_SEARCH);
  commit(types.HIDE_RESTROOMS);
  dispatch('switchFloorByShopId', shopId);
};

export const clearShop = ({ commit }) => {
  commit(types.CLEAR_SHOP);
};

export const toggleShop = ({ commit, state, getters, dispatch }, shopId) => {
  if (state.currentShop === shopId) {
    commit(types.CLEAR_SHOP);
  } else {
    dispatch('selectShop', shopId);
  }
};

export const selectCat = ({ commit }, catId) => {
  commit(types.SELECT_CAT, catId);
  commit(types.CLOSE_SEARCH);
};

export const clearCat = ({ commit }) => {
  commit(types.CLEAR_CAT);
};

export const toggleCat = ({ commit, state }, catId) => {
  if (state.currentCat === catId) {
    commit(types.CLEAR_CAT, catId);
  } else {
    commit(types.SELECT_CAT, catId);
    commit(types.CLOSE_SEARCH);
  }
};

export const openSearch = ({ commit }) => {
  commit(types.OPEN_SEARCH);
  commit(types.CLEAR_CAT);
  commit(types.CLEAR_SHOP);
  commit(types.UPDATE_PATH_FINDER_TARGET_SHOP, null);
};

export const closeSearch = ({ commit }) => {
  commit(types.CLOSE_SEARCH);
};

export const updateSearchQuery = ({ commit }, queryString) => {
  commit(types.UPDATE_SEARCH_QUERY, queryString);
};

export const startIdling = ({ commit }) => {
  commit(types.START_IDLING);
};

export const endIdling = ({ commit }) => {
  commit(types.END_IDLING);
};

export const toggleRestrooms = ({ commit, state }) => {
  if (state.showRestrooms) {
    commit(types.HIDE_RESTROOMS);
  } else {
    commit(types.CLEAR_SHOP);
    commit(types.SHOW_RESTROOMS);
  }
};

export const showShopModal = ({ commit }, shopId) => {
  commit(types.SHOW_SHOP_MODAL, shopId);
};

export const hideShopModal = ({ commit }) => {
  commit(types.HIDE_SHOP_MODAL);
};

export const showOffersModal = ({ commit }) => {
  commit(types.SHOW_OFFERS_MODAL);
};

export const hideOffersModal = ({ commit }) => {
  commit(types.HIDE_OFFERS_MODAL);
};

export const changeModalOffer = ({ commit }, offerId) => {
  commit(types.CHANGE_MODAL_OFFER, offerId);
};

export const enableAutoScrollToCurrent = ({ commit }) => {
  commit(types.ENABLE_AUTO_SCROLL_TO_CURRENT);
};

export const disableAutoScrollToCurrent = ({ commit }) => {
  commit(types.DISABLE_AUTO_SCROLL_TO_CURRENT);
};

export const updatePathFinderTargetShop = ({ commit, state, getters, dispatch }, shopId) => {
  commit(types.UPDATE_PATH_FINDER_TARGET_SHOP, shopId);
  if (shopId) {
    commit(types.SWITCH_FLOOR, getters.thisKioskData.floor);
  }
};

export const reset = ({ commit, state }) => {
  commit(types.HIDE_SHOP_MODAL);
  commit(types.HIDE_OFFERS_MODAL);
  commit(types.CLEAR_CAT);
  commit(types.CLEAR_SHOP);
  commit(types.UPDATE_PATH_FINDER_TARGET_SHOP, null);
  commit(types.HIDE_RESTROOMS);
  commit(types.CLOSE_SEARCH);
  commit(types.SWITCH_FLOOR, appConfig.kiosks[state.thisKioskId].floor);
  commit(types.SWITCH_LANGUAGE, 'et');
};
